/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import infoModule, { StoreSecretFilterInfoState } from './info';
import groupModule, { StoreSecretFilterGroupState } from './group';

export interface StoreSecretFilterState {
  // modules
  group: StoreSecretFilterGroupState;
  info: StoreSecretFilterInfoState;
}

export default {
  namespaced: true,
  modules: {
    info: infoModule,
    group: groupModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
